export default "__VITE_ASSET__DBxYM2dJ__"